import { upload } from '@/api/core'

import type { FileUploadReq, FileUploadRes } from './types'

/**
 * 用户上传文件的接口 max size:20M
 * @description https://api.yinnho.cn/api.php?do=file_upload&help
 *
 * @param data 请求参数
 */
export function file_upload (data: FileUploadReq) {
  return upload<FileUploadRes>('file_upload', data)
}
